<template>
  <div>
    <h4>いいね数が多い投稿</h4>
    <b-card-group deck>
      <div style="margin-bottom: 20px;" v-for="(post, index) in rankposts" :key="index">
        <b-card style="background-color: olivedrab;" text-variant="white" header="Book" class="text-center">
          <div class="teach" style="margin-right: 50px; display: inline-flex;">
            <p style="font-size: 5px; margin-right: 10px; margin-top: 4px;">本の名前</p>
            <h4>{{post.article.title}}</h4>
          </div>
          <p class="mt-2">オススメ度: {{ post.article.recommend }}</p>
          <div class="teach" style="margin-right: 50px; display: inline-flex;">
            <p style="font-size: 5px; margin-right: 10px; margin-top: 4px;">本のタイプ</p>
            <b-card-text style="font-size: 14px;">{{post.article.type}}</b-card-text>
          </div>
          <div class="teach" style="margin-right: 50px; display: inline-flex;">
            <p style="font-size: 5px; margin-right: 10px; margin-top: 4px;">メモ</p>
            <b-card-text>{{post.article.comment}}</b-card-text>
          </div>
          <p class="mt-2">いいね数: {{ post.rank }}</p>
        </b-card>
      </div>
    </b-card-group>
  </div>
</template>

<script>
export default {
  computed: {
    rankposts() {
      // いいねした値の取得。https://teratail.com/questions/263112#reply-377939を参考に。
      // まずはstoreからいいねされたpostを全て取得し、listに代入。
      const list = this.$store.state.rankings

      // groupBy(objectArray)を実行。objectArrayにはlistが入っている。
      function groupBy(objectArray) {

        // 処理が終わった後返り血をに入れる箱を用意。
        const result = []

        // objectArrayをeachで回して中身を取得。
        objectArray.forEach((element) => {

          // resultの箱にfindIndexをかけてindexに代入している。a.id === element.idはresultに既にある要素なのかを見ている。
          const index = result.findIndex((a) => a.id === element.id)

          // indexが0だった場合、つまり今までresultの箱に入っていなかったpostが来た時。
          if (index <= 0) {
            result.push({
              id: element.id,
              article: element,
              rank: 1
            })
          } 
          
          // resultにすでにあるpostだった場合。rankにプラス位置をかけている。
          else {
            result[index].rank += 1
          }
        })

        // この関数の返り値を決めている
        return result;
      }

      // 関数groupByをlistを実引数に入れて呼び出している。
      let resultData = groupBy(list)

      // 値を持ったresultDataをsortしてrankの値が大きい順に並び替えている
      return resultData.sort((a, b) => {

        // https://www.virment.com/how-to-create-computed-v-for/
        return (a.rank < b.rank) ? 1 : (a.rank > b.rank) ? -1 : 0;
      });
    }
  },
  created() {
    this.$store.dispatch('rank')
  },
}
</script>

<style scoped>
.text-white{
  width: 75%;
  margin: auto;
}
</style>